// extracted by mini-css-extract-plugin
export default {"icon":"ExpandableIcon-module_icon_ySztV","xs":"ExpandableIcon-module_xs_dJgul","sm":"ExpandableIcon-module_sm_vqMnT","md":"ExpandableIcon-module_md_KvsvY"};